export default [
  {
    dataField: 'id',
    caption: 'ID',
    dataType: 'integer',
    width: 50
  },
  {
    dataField: 'nome',
    caption: 'Nome'
  },
  {
    caption: 'Ações',
    cellTemplate: 'acaoCell',
    width: 100
  }
]
